import React from 'react';

import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { PUBLIC_KEY } from '@/constants/stripe';
import PropTypes from 'prop-types';

export default () => (Component) =>
  function StripeMiddleware(props) {
    const stripeState = loadStripe(PUBLIC_KEY);

    return (
      <Elements stripe={stripeState} appearance={{ theme: 'stripe' }}>
        <Component {...props} />
      </Elements>
    );
  };

export const StripeWrap = (props) => {
  const stripeState = loadStripe(PUBLIC_KEY);

  return (
    <Elements stripe={stripeState} appearance={{ theme: 'stripe' }}>
      {props?.children}
    </Elements>
  );
};

StripeWrap.propTypes = {
  children: PropTypes.node.isRequired,
};
